import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import urls from '@routes/urls';
import { handleLogin } from '@store/features/auth/token/actions';
import { authTokenSelector } from '@store/features/auth/token/selectors';
import { removeToken, updateTokens } from '@store/features/auth/token/slice';
import { userDataSelector } from '@store/features/auth/user/selectors';
import { removeUserProfile } from '@store/features/auth/user/slice';
import useDispatch from '@store/hooks/useDispatch';
import {
  getAuthCodeFromUrl,
  getAuthTokenFromLocalStorage,
  getRefreshTokenFromLocalStorage,
} from '@utils/token';

import { IProtectedRouteProps } from './ProtectedRoute.interface';

const ProtectedRoute: FC<IProtectedRouteProps> = ({ admin, children }) => {
  const dispatch = useDispatch();

  const authToken = getAuthTokenFromLocalStorage();
  const refreshToken = getRefreshTokenFromLocalStorage();
  const storeAuthToken = useSelector(authTokenSelector);
  const newAuthCode = getAuthCodeFromUrl();
  const user = useSelector(userDataSelector);

  if (newAuthCode) {
    dispatch(handleLogin(newAuthCode));

    return <Navigate to={urls.home} replace />;
  }

  if (authToken && !storeAuthToken) {
    dispatch(
      updateTokens({
        authToken,
        refreshToken: refreshToken || null,
      }),
    );
  }

  if (admin && !user?.isAdmin) {
    return <Navigate to={urls.home} replace />;
  }

  if (!authToken) {
    dispatch(removeToken());
    dispatch(removeUserProfile());
    return <Navigate to={urls.login} replace />;
  }

  return children;
};

export default ProtectedRoute;
